module.exports = __webpack_public_path__ + "img/9.094fe594.jpg";